import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';

import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import CheckBoxItem from 'base/components/CheckBoxItem';
import VariantFieldSet from 'base/components/VariantFieldSet';

const styles = theme => ({
  container: {
    display: 'flex'
  },
  text: {
    flexGrow: 1,
    lineHeight: '42px',
    textAlign: 'right'
  },
  color: {
    color: theme.palette.text.disabled
  }
});

class CheckBoxGroup extends React.Component {
  static propTypes = {
    list: PropTypes.array,
    title: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.object,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    selectionSatisfied: PropTypes.bool,
    classes: PropTypes.object,
    helperText: PropTypes.string
  };
  static defaultProps = {
    value: {}
  };

  /**
   * This handles the change for when a user update a checkbox.
   * We maintain the value of existing checkboxes, and add/overwrite
   * the checkbox value that the user just interacted with.
   * value props stored ex:
   * {
   *  ketchup: false,
   *  mayo: true,
   *  mustard: true
   * }
   */
  handleCheckBoxChange = event => {
    const { onChange, value } = this.props;
    onChange({
      ...value,
      [event.target.name]: event.target.checked
    });
  };

  renderCheckboxGroup = () => {
    const { list, disabled, value, classes } = this.props;
    return list.map((item, index) => {
      const { label, price } = item;
      const selectedValue = item.value;
      return (
        <React.Fragment key={index}>
          <Grid className={classes.container} container>
            <Grid item>
              <CheckBoxItem
                checked={!!value[selectedValue]}
                name={selectedValue}
                label={label}
                value={selectedValue}
                disabled={disabled && !this.props.value[selectedValue]}
                onChange={this.handleCheckBoxChange}
              />
            </Grid>
            <Grid item className={classes.text}>
              <Typography
                component="span"
                id="item-price"
                className={
                  disabled && !this.props.value[selectedValue] && classes.color
                }
              >
                {price ? `+$${price}` : ' '}
              </Typography>
            </Grid>
          </Grid>
        </React.Fragment>
      );
    });
  };

  render() {
    const { title, required, selectionSatisfied, helperText } = this.props;
    return (
      <VariantFieldSet
        title={title}
        required={required}
        selectionSatisfied={selectionSatisfied}
        helperText={helperText}
      >
        <FormGroup>
          <Grid container>{this.renderCheckboxGroup()}</Grid>
        </FormGroup>
      </VariantFieldSet>
    );
  }
}

export default withStyles(styles)(CheckBoxGroup);
